// API URL configuration utility
export const getApiUrl = (): string => {
  // Use environment variable if set (check both possible names)
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  
  // A production build with no API URL configured has nowhere to go, and the
  // honest answer is to say so rather than to pick an account.
  //
  // This used to fall back to Waddle & Sip's API, which was correct while
  // there was one account and is the exact assumption this console is being
  // separated from. A misconfigured deployment now fails at startup with its
  // own name on the error, instead of quietly talking to somebody else's
  // backend.
  if (import.meta.env.PROD) {
    throw new Error(
      'No API URL configured. Set VITE_API_BASE_URL to the backend this '
      + 'deployment should talk to.',
    );
  }

  return 'http://localhost:3001';
};

// Helper function to build API endpoints
export const buildApiUrl = (endpoint: string): string => {
  const baseUrl = getApiUrl();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
}; 